import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { InsuranceSumAndPremium } from '../models/insurance-sum-and-premium.model';

@Injectable({
    providedIn: 'root'
})
export class SendingSumAndPremiumInfoService {
    private info: Subject<InsuranceSumAndPremium> = new BehaviorSubject<InsuranceSumAndPremium>(new InsuranceSumAndPremium({}));

    get info$() {
        return this.info.asObservable();
    }

    addSumAndPremiumInfo(basicInfo: InsuranceSumAndPremium) {
        this.info.next(basicInfo);
    }

}